// production 为生产环境配置
// 此设置是通过import标志，使用webpack打包匹配到文件路径最终将src/modules/xxx.vue 文件都做成一个文件路径映射关系（Map)
/*
 *   {
 *        [path]: render() 模板渲染函数或Vnode对象
 *    }
 */
// require 是common.js 模式在nodejs环境运行才生效
// import 在生产模式打包时还可用做懒加载方式
module.exports = file => () =>
    import ('@/views/' + file + '.vue')
    // module.exports = file => require('@/modules/' + file + '.vue').default // vue-loader at least v13.0.0+ // 获取出错误